import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FiExternalLink } from 'react-icons/fi';
import WhiteList from "../../config/whitelistAttributes.json";

const CallAttributes = () => {
    const contactAttributes = useSelector((state:any)=>{return state.contactAttributeSlice?.contactAttributes})
    const selectedContactId = useSelector((state:any)=>{return state.contactAttributeSlice?.selectedContact})
    const selectedContact = contactAttributes?.filter((item:any) => item.contactId === selectedContactId)[0]
    const [displayAttributes, setDisplayAttributes] = useState<any>([]);
    
    useEffect(()=>{
        let contactDisplayAttributes = selectedContact?.contactAttributes
        if(contactDisplayAttributes) {
            let result = Object.entries(contactDisplayAttributes).map((item:any)=>{
                var attr:any = Object.assign({})
                attr.attributeName = item[0] 
                attr.value = item[1].value
                return attr;
            })
            setDisplayAttributes(result)
        } else {
            setDisplayAttributes([])
        }
    },[selectedContact])

    return (
        <React.Fragment>
            <div className="card call-attributes collapse show mt-3" id="call_attributes">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className='m-0'>Contact attributes</h6>
                </div>
                <div className="card-body height-400">
                    <div className='row'>
                        <div className='col-12'>
                            <table className='table table-striped table-borderless border'>
                                <tbody>
                                    <tr>
                                        <th colSpan={3}>
                                            <h6 className='m-0'>Basic attributes</h6>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td style={{fontWeight: "bold"}}>Phone</td>
                                        <td>:</td>
                                        <td>
                                            {selectedContact?.phone}  
                                            {selectedContact?.contactAttributes?.ServiceNowLookup?.value && <button type="button" className="btn btn-primary" style={{fontSize: "14px", marginLeft: "58%"}} onClick={() => window.open(selectedContact?.contactAttributes?.ServiceNowLookup?.value + "+" + selectedContact?.phone.replace(/\D/g, ""), '_blank') }>
                                                {"To ITSM Tool "}
                                                <FiExternalLink size={16} color={"white"} style={{marginBottom: "0.4rem"}}/>
                                            </button>}
                                            {selectedContact?.contactAttributes?.ServiceNowCaseOpen?.value && <button type="button" className="btn btn-primary" style={{fontSize: "14px", marginLeft: "58%"}} onClick={() => window.open(selectedContact?.contactAttributes?.ServiceNowCaseOpen?.value + "+" + selectedContact?.phone.replace(/\D/g, ""), '_blank') }>
                                                {"Open PrePopulated Incident"}
                                                <FiExternalLink size={16} color={"white"} style={{marginBottom: "0.4rem"}}/>
                                            </button>}
                                        </td>

                                    </tr>
                                    <tr>
                                        <th>Queue</th>
                                        <td>:</td>
                                        <td>{ selectedContact?.queueName ?? '-'  }</td>
                                    </tr>
                                    <tr>
                                        <th colSpan={3}>
                                            <h6 className='m-0'>Additional attributes</h6>
                                        </th>
                                    </tr>
                                    {displayAttributes.length > 0 && displayAttributes?.map((item:any, index:any)=>{
                                        if(WhiteList.attributes?.includes(item.attributeName)) {
                                            return (
                                                <tr key={index}>
                                                    <th>{item.attributeName}</th>
                                                    <td>:</td>
                                                    <td>{ item.value }</td>
                                                </tr>
                                            )    
                                        }
                                        return ''
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                   
                </div>
            </div>
        </React.Fragment>
    )
}
export default CallAttributes;